import React, { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom';
import UserDataTable from '../../../components/userAdminPanel/Components/UserDataTable/UserDataTable';
import { allUserAssetsColumns } from '../../../datatablesource';
import { handleUserError } from '../../../utils/error';
import userRequest from "../../../utils/userRequest";
import "../Styles/PrintingAsset.scss";
import ViewportMeta from '../../../utils/ViewportMeta';
import swal from 'sweetalert';
import { useTranslation } from 'react-i18next';

const NewAssetGenerate2 = () => {
  const { t, i18n } = useTranslation()
  const navigate = useNavigate();
  const [data, setData] = useState([]);
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [isAuthenticating, setIsAuthenticating] = useState(true);
  const [allAssetsList, setAllAssetsList] = useState([]);
  const [fetchDataState, setFetchDataState] = useState(false);
  const [varificationTagData, setVarificationTagData] = useState([]);

  useEffect(() => {
    const getAllAssetsList = async () => {
      try {

        userRequest.get("/getAllAssetMasterEncodeAssetCaptureWithNoTag")
          .then(response => {
            const sortedData = response.data.sort((a, b) => new Date(b.assetdatecaptured) - new Date(a.assetdatecaptured));
            response.data == "no data available" ? setData([]) : setData(response.data);
            // console.log(response?.data);
            setVarificationTagData(response?.data)
             setIsAuthenticating(false);

          })
          .catch(error => {
            handleUserError(error)
            console.error(error);
             setIsAuthenticating(false);
          });

      }
      catch (error) {
        console.log(error);
        setIsAuthenticated(false);
        setIsAuthenticating(false);
        // navigate("/userLogin");
      }
    };
    getAllAssetsList();
  }, [fetchDataState]);


  const handleApiCall = () => {

    userRequest.get("/UpdateAssetMasterEncodeAssetCaptureTagNumber", data)
      .then(response => {
        // handle the API response
        console.log(response?.data);
        // call api to post varification data map to varification tag data 

        setFetchDataState(!fetchDataState);
        swal({
          title: "Tags Generated",
          text: "Tags updated successfully.",
          icon: "success"

        })
        navigate(-1)

        navigate('/member/assets');
      })

      .catch(error => {
        console.error(error);
        swal({
          title: "Tags Generation Failed",
          text: "Tags updation failed.",
          icon: "error"

        })
        handleUserError(error)
      });
  }

  return (
    <div>
       <div className={`p-0 h-full ${i18n.language === 'ar' ? 'sm:mr-72' : 'sm:ml-72'}`}>
      
      <ViewportMeta />
      <UserDataTable
        actionColumnVisibility={false}
        secondaryColor="secondary"
         loading={isAuthenticating}
        data={data} columnsName={allUserAssetsColumns(t)} handleApiCall={handleApiCall} UniqueId="GenerateTagsId" title={t("Generate New Tags")} backButton={true} />
    </div>
    </div>
  )
}

export default NewAssetGenerate2